module.exports = __webpack_public_path__ + "static/media/transparent_expansion.c56ac578.svg";